import React from "react";

/** Small "● MEMO" badge shown on memo (consignment) products. */
export default function MemoBadge({ size = "sm", className = "" }) {
  const cls = size === "lg" ? "text-xs px-2.5 py-1" : "text-[10px] px-2 py-0.5";
  return (
    <span
      data-testid="memo-badge"
      className={`inline-flex items-center gap-1 ${cls} rounded-full border border-emerald-300 bg-emerald-100 text-emerald-700 font-semibold uppercase tracking-wider ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block"></span>
      MEMO
    </span>
  );
}
